import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useApp } from '../context/AppContext';
import { destinations } from '../mock/mock';
import { slugify } from '../mock/guides';

const Destinations = () => {
  const { t } = useApp();
  return (
    <section id="destinations" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="max-w-3xl mb-12">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-[color:var(--brand-dark)]">{t('dest.title')}</h2>
          <p className="mt-4 text-gray-500 leading-relaxed">{t('dest.subtitle')}</p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
          {destinations.map((d, i) => (
            <Link to={`/guide/${slugify(d.name)}`} key={i} className="card-hover group relative rounded-2xl overflow-hidden block" data-testid={`dest-card-${i}`}>
              <img src={d.img} alt={d.name} className="w-full h-48 object-cover transition-transform duration-500 group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <div className="text-[11px] font-semibold uppercase tracking-wide" style={{ color: 'var(--brand-accent)' }}>{d.country}</div>
                <div className="text-white font-bold text-sm mt-0.5">{d.name}</div>
              </div>
            </Link>
          ))}
        </div>
        <div className="mt-10 text-center">
          <a href="#destinations" className="inline-flex items-center gap-2 rounded-full px-6 py-3 font-bold text-sm border-2 transition-colors hover:bg-[color:var(--brand-dark)] hover:text-white" style={{ borderColor: 'var(--brand-dark)', color: 'var(--brand-dark)' }}>
            {t('dest.all')} <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Destinations;
